import { Button } from '@/components/ui/button.js';
import { TriangleAlertIcon, XIcon } from 'lucide-react';
import { ReactNode, useState } from 'react';

interface AlertBannerProps {
  title: ReactNode;
  content: ReactNode;
  canDismiss?: boolean;
}

export const AlertBanner = ({ title, content, canDismiss = false }: AlertBannerProps) => {
  const [visible, setVisible] = useState(true);

  return (
    visible && (
      <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 dark:bg-gray-800 dark:border-yellow-500">
        <div className="flex items-center">
          <div className="flex-shrink-0">
            <TriangleAlertIcon className="h-5 w-5 text-yellow-400 dark:text-yellow-500" />
          </div>
          <div className="ml-3">
            {title && <h3 className="text-sm font-medium text-yellow-800 dark:text-yellow-200">{title}</h3>}
            <div className="mt-2 text-sm text-yellow-700 dark:text-yellow-300">{content}</div>
          </div>
          <div className="ml-auto pl-3">
            {canDismiss && (
              <div className="-mx-1.5 -my-1.5">
                <Button
                  variant="ghost"
                  size="sm"
                  className="rounded-md p-1.5 text-yellow-500 hover:bg-yellow-100 focus:outline-none focus:ring-2 focus:ring-yellow-500 dark:text-yellow-400 dark:hover:bg-gray-700 dark:focus:ring-yellow-600"
                  onClick={() => setVisible(false)}
                >
                  <span className="sr-only">Dismiss</span>
                  <XIcon className="h-5 w-5" />
                </Button>
              </div>
            )}
          </div>
        </div>
      </div>
    )
  );
};
